var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationsFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8001 9.99375C11.4314 9.35625 10.9876 8.14375 10.9876 6V5.55625C10.9876 2.7875 8.76886 0.51875 6.03761 0.5H6.00011C5.34433 0.50082 4.69512 0.6308 4.08956 0.882517C3.48401 1.13423 2.93396 1.50276 2.47083 1.96705C2.0077 2.43135 1.64055 2.98231 1.39035 3.5885C1.14015 4.19468 1.01179 4.84421 1.01261 5.5V6C1.01261 8.14375 0.568863 9.35625 0.200113 9.99375C0.110933 10.1457 0.0634651 10.3184 0.0625146 10.4946C0.0615641 10.6708 0.107164 10.844 0.194701 10.9969C0.282237 11.1498 0.408602 11.2768 0.561009 11.3652C0.713415 11.4535 0.886454 11.5 1.06261 11.5H3.50011C3.50011 12.163 3.76351 12.7989 4.23235 13.2678C4.70119 13.7366 5.33707 14 6.00011 14C6.66316 14 7.29904 13.7366 7.76788 13.2678C8.23672 12.7989 8.50011 12.163 8.50011 11.5H10.9376C11.1137 11.5011 11.287 11.4554 11.4396 11.3676C11.5923 11.2797 11.7189 11.1529 11.8064 11C11.8931 10.8463 11.9382 10.6726 11.9371 10.496C11.936 10.3195 11.8888 10.1464 11.8001 9.99375ZM6.00011 13C5.6028 12.9984 5.22222 12.8398 4.94127 12.5588C4.66032 12.2779 4.50176 11.8973 4.50011 11.5H7.50011C7.49847 11.8973 7.33991 12.2779 7.05896 12.5588C6.77801 12.8398 6.39743 12.9984 6.00011 13Z",
    fill: "#3182CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsFull);
export default __webpack_public_path__ + "static/media/notificationsFull.8592b97d.svg";
export { ForwardRef as ReactComponent };